import {all, fork} from "redux-saga/effects";
import {put, takeEvery} from "@redux-saga/core/effects";
import {
    deleteElement, deleteElementError, deleteElementSuccess,
    getAllElement,
    getAllElementError,
    getAllElementSuccess,
    saveElement, saveElementError,
    saveElementSuccess,
    TenantElement, updateElement, updateElementError, updateElementSuccess
} from "../reducers/Tenant/TenantReducer";
import {CustomFetch, CustomFetchResponse} from "../utils/CustomFetch";
import apiPaths from "../config/apiPaths";
import {PayloadAction} from "@reduxjs/toolkit";
import {openSnackbar} from "../reducers/snackbar/snackbarReducer";


function* getAllElementSaga(){
    yield takeEvery(getAllElement.type, function* () {
        let response : CustomFetchResponse = yield CustomFetch({
            method: "GET",
            url: apiPaths.allTenant,
            authenticated: true})

        if (response.status === 200){
            yield put({type: getAllElementSuccess.type, payload: response.data})
        } else {
            yield put({type: getAllElementError.type})
        }
    })
}

function* saveElementSaga(){
    yield takeEvery(saveElement.type, function* (action: PayloadAction<TenantElement>) {
        let response: CustomFetchResponse = yield CustomFetch({method: "POST", url: apiPaths.saveTenant, authenticated: true, data: action.payload})

        if (response.status === 200){
            yield put({type: saveElementSuccess.type, payload: response.data})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element added successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
        } else {
            yield put({type: saveElementError.type})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Tenant not added',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            })
        }


    })
}

function* deleteElementSaga() {
    yield takeEvery(deleteElement.type, function* (action: PayloadAction<string>) {



        const url = `${apiPaths.deleteTenant}/${action.payload}`
        let response: CustomFetchResponse = yield CustomFetch({
            method: "DELETE",
            url: url,
            authenticated: true,
            data: action.payload})

        if(response.status === 200){
            yield put({type: deleteElementSuccess.type, payload: response.data.content})
            yield put({type: getAllElement.type})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element deleted successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })

        } else {
            yield put({ type: deleteElementError.type });
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Element not deleted',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            });
        }
    })
}
function* updateElementSaga() {
    yield takeEvery(updateElement.type, function* (action: PayloadAction<TenantElement>) {

        const url = `${apiPaths.updateTenant}/${action.payload._id}`
        let response: CustomFetchResponse = yield CustomFetch({method: "PUT",
            url: url,
            authenticated:true ,
            data: action.payload})

        if (response.status === 200){
            yield put ({
                type: updateElementSuccess.type,
                payload: response.data
            })
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element update',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
            yield put({type: getAllElement.type})

        }
        else {
            yield put ({
                type: updateElementError.type,
            })
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element not update',
                    variant: 'alert',
                    alert: {
                        color: 'warning'
                    }
                }
            })
        }
    });
}


export default function* TenantSag() {
    yield all(
        [
            fork(getAllElementSaga),
            fork(saveElementSaga),
            fork(updateElementSaga),
            fork(deleteElementSaga)
        ]
    )

}